import { IconProps } from "./HomeIcon";

const DoubleRightArrowIcon = ({ color = "#CCCCCC" }: IconProps) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group 3465525">
        <path
          id="Vector 1"
          d="M1 11L6 6L1 1"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector 2"
          d="M6 11L11 6L6 1"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default DoubleRightArrowIcon;
